import * as ko from "knockout";
import "./../../bindings/c3chart";
function TagReportTabResultListViewModel(tabPage, diagramDataSet, ticks) {
    var self = this;
    self.TabPage = tabPage;
    self.PlotObj = ko.observable();
    self.DiagramDataSet = diagramDataSet;
    self.Ticks = ticks;
    self.Refresh = function () { };
}
;
export default TagReportTabResultListViewModel;